import { useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';
import { Editor } from 'react-draft-wysiwyg';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button/Button';
import Input from 'components/Input/Text/Input';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';

import QuizSubTitle from '../QuizSubHeader/QuizSubHeader';
import questions from '../data/questions';

import './QuizQuestions.scoped.scss';

const initialResult = { correctAnswers: 0, totalAnswers: 0, totalOpenAnswers: 0 };

const QuizStarter = () => {
  const history = useHistory();
  const [questionNr, setQuestionNr] = useState(0);
  const [answer, setAnswer] = useState(null);

  const [result, setResult] = useState(initialResult);
  const [loading, setLoading] = useState(false);

  const [validationFail, setValidationFail] = useState(false);

  const { t, i18n } = useTranslation('study');

  const nextHandler = () => {
    if (!answer && questions[i18n.language][questionNr].details.type === 'option') {
      setValidationFail(true);
      return;
    }

    setLoading(true);

    if (answer === questions[i18n.language][questionNr].details.correctAnswer) {
      setResult(prevState => ({
        ...result,
        correctAnswers: prevState.correctAnswers + 1,
      }));
    }

    if (questions[i18n.language] && questions[i18n.language].length === questionNr + 1) {
      history.push('/quiz/result');
      window.localStorage.setItem('quizResult', JSON.stringify(result));
    } else {
      setQuestionNr(prevState => prevState + 1);
      setAnswer(null);

      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const prevHandler = () => {
    if (questionNr !== 0) setQuestionNr(prevState => prevState - 1);
  };

  useEffect(() => {
    const isOptionType = questions[i18n.language][questionNr].details.type === 'option';
    setResult(prevState => ({
      ...result,
      totalAnswers: prevState.totalAnswers + (isOptionType ? 1 : 0),
      totalOpenAnswers: prevState.totalOpenAnswers + (isOptionType ? 0 : 1),
    }));
  }, [questionNr]);

  return (
    <div className="quizstarter-container">
      <div className="counter-container">
        <div className="counter">
          <h5>{questionNr + 1}</h5>
        </div>
      </div>

      <QuizSubTitle title={questions[i18n.language][questionNr].title} loading={loading} />

      {loading ? (
        <div>
          <LoadingIndicator style={{ height: '100px' }} />
        </div>
      ) : questions[i18n.language][questionNr].details.type === 'option' ? (
        <div className="answer">
          <ul className="options">
            {questions[i18n.language][questionNr].details.options.map((option, index) => (
              <li key={index}>
                <label>
                  <Input
                    type="radio"
                    name={`${questions[i18n.language][questionNr].title}`}
                    value={option}
                    onChange={answer => {
                      if (validationFail) setValidationFail(false);
                      setAnswer(answer);
                    }}
                    containerStyle={{ width: 30 }}
                  />
                  {option}
                </label>
              </li>
            ))}
          </ul>
          {validationFail && (
            <span style={{ color: 'red', fontSize: '14px' }}>
              {t('Please select at least one option!')}
            </span>
          )}
        </div>
      ) : (
        <div className="answer">
          <Editor
            localization={{
              locale: i18n.language,
            }}
            toolbar={{
              options: [
                'fontFamily',
                'fontSize',
                'blockType',
                'inline',
                'list',
                'textAlign',
                'history',
              ],
              inline: { inDropdown: true },
              list: { inDropdown: true },
              textAlign: { inDropdown: true },
              link: { inDropdown: true },
              history: { inDropdown: true },
            }}
            toolbarStyle={{
              borderRadius: 10,
              background: '#F2F7FC',
              border: 'none',
            }}
            wrapperStyle={{
              backgroundColor: 'white',
              borderRadius: 10,
              padding: 12,
              border: '1px solid #CFD6DD',
              marginTop: '20px',
            }}
            editorStyle={{
              borderRadius: '0px 0 10px 10px',
              backgroundColor: 'white',
              minHeight: 100,
              width: '100%',
              maxHeight: '145px',
            }}
            placeholder={t('This is where a note would be typed')}
          />
        </div>
      )}

      <div className="controller">
        <Button
          onClick={prevHandler}
          round
          style={{
            backgroundColor: 'white',
            border: '2px solid #5CD79E',
            width: '130px',
            color: '#000',
            margin: '0px 30px',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          {t('previous')}
        </Button>
        <Button
          onClick={nextHandler}
          round
          style={{
            backgroundColor: '#5CD79E',
            border: '2px solid #5CD79E',
            width: '130px',
            color: '#fff',
            margin: '0px 30px',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          {t('next_question')}
        </Button>
      </div>
    </div>
  );
};

export default QuizStarter;
